import React from "react";
import FlyoutMenu from "./FlyoutMenu";

export default function ControlBar({
  handleAddToSelection,
  exportFormat,
  setExportFormat,
  exportLoading,
  handleExportDesign,
  setData,
  isMenuOpen,
  setIsMenuOpen,
  handleAddRoomToCatalog,
  addingToCatalog,
  handleDownloadCatalog,
  downloadingCatalog,
  selectionLoading,
  sessionRooms,
  clearCatalogSession
}) {
  return (
    <div className="flex items-center bg-white border border-gray-200 rounded-lg shadow-sm pointer-events-auto divide-x divide-gray-200 relative">
      {/* Add to Selection */}
      <div className="flex items-center px-1">
        <button
      onClick={handleAddToSelection}
      disabled={selectionLoading}
      className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-black hover:bg-gray-50 rounded-md transition-colors flex items-center gap-2"
    >
      <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
      </svg>
      {selectionLoading ? "Saving..." : "Add to Selection"}
    </button>
        <button className="p-2 text-gray-400 hover:text-gray-600 rounded-md hover:bg-gray-50">
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
        </button>
      </div>

      {/* Export / Download */}
      <div className="flex items-center gap-1 px-1">
        <select
          value={exportFormat}
          onChange={(event) => setExportFormat(event.target.value)}
          disabled={exportLoading}
          className="px-3 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium disabled:cursor-not-allowed disabled:bg-gray-100 text-sm"
        >
          {/* <option value="pdf">PDF</option> */}
          <option value="png">PNG</option>
          <option value="jpg">JPG</option>
        </select>
        <button
          onClick={handleExportDesign}
          disabled={exportLoading}
          className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium flex items-center gap-2 text-sm disabled:cursor-not-allowed disabled:bg-gray-100"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
          {exportLoading ? "Exporting..." : "Export"}
        </button>
      </div>

      {/* Change Room */}
      <button
        onClick={() => setData(null)}
        className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-black hover:bg-gray-50 transition-colors flex items-center gap-2"
      >
        <svg
          className="w-4 h-4 text-gray-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 00-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
        Change Room
      </button>

      {/* Menu Dropdown Button */}
      <FlyoutMenu
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        handleAddRoomToCatalog={handleAddRoomToCatalog}
        addingToCatalog={addingToCatalog}
        handleDownloadCatalog={handleDownloadCatalog}
        downloadingCatalog={downloadingCatalog}
        sessionRooms={sessionRooms}
        clearCatalogSession={clearCatalogSession}
      />
    </div>
  );
}
